import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTreeContext } from "../../context/TreeDataContext";
import { useTemplateContext } from "../../context/TemplateContext";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";
import Loader from "../../Layouts/Loader/Loader";
import ErrorMessage from "../../components/FormComponents/ErrorMessage";
import EmailTemplateViewer from "./EmailTemplateViewer/EmailTemplateViewer";
import SmsTemplateViewer from "./SmsTemplateViewer/SmsTemplateViewer";
import WhatsappTemplateViewer from "./WhatsappTemplateViewer/WhatsappTemplateViewer";
import SlackTemplateViewer from "./SlackTemplateViewer/SlackTemplateViewer";
import TelegramTemplateViewer from "./TelegramTemplateViewer/TelegramTemplateViewer";
import PdfTemplateViewer from "./PdfTemplateViewer/PdfTemplateViewer";
import GoogleDocTemplateViewer from "./GoogleDocTemplateViewer/GoogleDocTemplateViewer";
import ExcelTemplateViewer from "./ExcelTemplateViewer/ExcelTemplateViewer";
import AccessTemplateViewer from "./AccessTemplateViewer/AccessTemplateViewer";
import MasterDataTemplateViewer from "./MasterDataTemplateViewer/MasterDataTemplateViewer";
import MongoTemplateViewer from "./MongoTemplateViewer/MongoTemplateViewer";
import RecordviewTemplateViewer from "./RecordviewTemplateViewer/RecordviewTemplateViewer";
import OcrTemplateViewer from "./OcrTemplateViewer/OcrTemplateViewer";
import ReactComponentTemplateViewer from "./ReactComponentTemplateViewer/ReactComponentTemplateViewer";
import AiAssistantTemplateViewer from "./AiAssistantTemplateViewer/AiAssistantTemplateViewer";
import ApiForwardingTemplateViewer from "./ApiForwardingTemplateViewer/ApiForwardingTemplateViewer";
import { updateInitialAndModifiedConfig } from "../../utils/configChecksum/checksumStore";

const TemplateCenterViewer = () => {
  const { templateId } = useParams();
  const navigate = useNavigate();

  const { templateExplorerData } = useTreeContext();
  const { selectedTemplate, setSelectedTemplate } = useTemplateContext();

  // Keep this as-is (your provided effect)
  useEffect(() => {
    if (!templateExplorerData || selectedTemplate.id === templateId) return;

    const file = getFolderFileById(templateExplorerData, templateId);
    if (file) {
      setSelectedTemplate({
        id: file.id,
        name: file.name,
        parentData: file.parentData
      });
      updateInitialAndModifiedConfig(null);
    } else {
      navigate("../");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId]);

  // Handle case where no template is selected
  if (!templateId || !templateExplorerData) {
    return (
      <div className="content_main_section d_flex justify_center align_center h_100">
        <h3 style={{ color: "#667085" }}>Please select a template</h3>
      </div>
    );
  }
  console.log("selectedTemplaye", selectedTemplate);
  // Handle loading before parentData is set
  if (!selectedTemplate?.parentData) return <Loader />;

  const renderViewer = () => {
    switch (selectedTemplate.parentData) {
      case "email":
        return <EmailTemplateViewer file={selectedTemplate} />;
      case "sms":
        return <SmsTemplateViewer file={selectedTemplate} />;
      case "whatsapp":
        return <WhatsappTemplateViewer file={selectedTemplate} />;
      case "telegram":
        return <TelegramTemplateViewer file={selectedTemplate} />;
      case "slack":
        return <SlackTemplateViewer file={selectedTemplate} />;
      case "pdf_template":
        return <PdfTemplateViewer file={selectedTemplate} />;
      case "googledoc":
        return <GoogleDocTemplateViewer file={selectedTemplate} />;
      case "exceldoc":
        return <ExcelTemplateViewer file={selectedTemplate} />;
      case "access-templates":
        return <AccessTemplateViewer file={selectedTemplate} />;
      case "masterdata":
        return <MasterDataTemplateViewer file={selectedTemplate} />;
      case "mongo-template":
        return <MongoTemplateViewer file={selectedTemplate} />;
      case "recordview-template":
        return <RecordviewTemplateViewer file={selectedTemplate} />;
      case "ocr":
        return <OcrTemplateViewer file={selectedTemplate} />;
      case "custom-component":
        return <ReactComponentTemplateViewer file={selectedTemplate} />;
      case "ai-assistant-template":
        return <AiAssistantTemplateViewer file={selectedTemplate} />;
      case "api-forwarding-template":
        return <ApiForwardingTemplateViewer file={selectedTemplate} />;
      default:
        return (
          <div className="d_flex justify_center align_center h_100">
            <ErrorMessage>Unsupported template type: {selectedTemplate.parentData}</ErrorMessage>
          </div>
        );
    }
  };

  return <div className="content_main_section">{renderViewer()}</div>;
};

export default TemplateCenterViewer;
